import { StatLabel as ChakraStatLabel, StatLabelProps } from '@chakra-ui/react';
import * as React from 'react';

const StatLabel: React.FC<React.PropsWithChildren<StatLabelProps>> = (
  props,
) => (
  <ChakraStatLabel
    fontWeight="medium"
    isTruncated
    color="gray.500"
    {...props}
  />
);

export default StatLabel;
